// NOTE: this is used to refetch translations after the new build. Version will be inserted while building

export const TRANSLATIONS_VERSION = '__TRANSLATIONS_VERSION__';
